/**
 * Города экрана списка партнёров 2.8.2 (Блок 8, ADR-0080). UI-источник истины —
 * прототип `Партнеры/01-prototype-vanilla/screen-2.8-partners.html` (`CITIES`).
 *
 * 20 городов в ФИКСИРОВАННОМ порядке (точь-в-точь, как `PARTNER_CATEGORIES` —
 * канон, P-001). Дефолт селекта — «Астана» (профиль-дефолт появится позже, когда
 * будет профиль). Данные в каталоге сейчас есть только по Астане; остальные города
 * → пустое состояние «Скоро появятся» (по данным, P-021).
 *
 * Это СПИСОК ВЫБОРА (UI), а НЕ список «городов с данными»: эндпоинт
 * `/api/partners/cities` отдаёт только города с партнёрами — здесь же показываем
 * весь справочник, чтобы пользователь мог выбрать свой город и увидеть «Скоро
 * появятся» (а не отсутствие города в списке).
 */
export const PARTNER_CITIES = [
  'Астана',
  'Алматы',
  'Ташкент',
  'Москва',
  'Санкт-Петербург',
  'Новосибирск',
  'Екатеринбург',
  'Краснодар',
  'Нижний Новгород',
  'Люберцы',
  'Красногорск',
  'Одинцово',
  'Мытищи',
  'Балашиха',
  'Химки',
  'Котельники',
  'Подольск',
  'Зеленоград',
  'Солнечногорск',
  'Щёлково',
] as const;

export type PartnerCity = (typeof PARTNER_CITIES)[number];

/** Город по умолчанию в селекте (профиль-дефолт появится позже). */
export const DEFAULT_PARTNER_CITY: PartnerCity = 'Астана';
